export type AdobeDefaultViewMode =
	| "FIT_PAGE"
	| "FIT_WIDTH"
	| "TWO_COLUMN"
	| "TWO_COLUMN_FIT_PAGE";

const ADOBE_DEFAULT_VIEW_MODES: readonly AdobeDefaultViewMode[] = [
	"FIT_PAGE",
	"FIT_WIDTH",
	"TWO_COLUMN",
	"TWO_COLUMN_FIT_PAGE",
];

export function resolveAdobeDefaultViewMode(raw: string | undefined | null): AdobeDefaultViewMode {
	if (raw === undefined || raw === null || raw.trim() === "") {
		return "FIT_PAGE";
	}
	const normalized = raw.trim().toUpperCase().replace(/-/g, "_");
	if (ADOBE_DEFAULT_VIEW_MODES.includes(normalized as AdobeDefaultViewMode)) {
		return normalized as AdobeDefaultViewMode;
	}
	return "FIT_PAGE";
}

/** File segment including `.pdf` from Layout Service `mediaId` query (path or absolute media URL). */
export function extractPdfFileNameFromMediaId(mediaId: string | null): string | null {
	if (!mediaId) return null;
	try {
		let pathPart = mediaId;
		if (mediaId.startsWith("http")) {
			pathPart = new URL(mediaId).pathname;
		}
		const decodedPath = decodeURIComponent(pathPart);
		const match = decodedPath.match(/([^/]+\.pdf)$/i);
		return match?.[1] ?? null;
	} catch {
		return null;
	}
}
